import BaseApiAction from '@Actions/base-api-action';

export default class CreatePlaylistSession extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'playlistsV2-createPlaylistSession',
      payload: { 
        account_id: this._payload.account_id,
        playlist_id: this._payload.playlist_id,
      },
    });
  }
} 